import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { canManageCourseAssignment } from '@BUP/services/BraveUp'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import { UserContext } from '@BUP/contexts/UserContext'

const CourseAssignmentManagerRoute = ({ children }) => {
  const organization = useContext(OrganizationContext)
  const user = useContext(UserContext)

  if (!canManageCourseAssignment(organization, user)) return <Navigate to='/' />
  return children
}

export default CourseAssignmentManagerRoute
